import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { DebitcardUSStatus } from "api"
import { endpoints } from "api"
import useDebitcardUS from "./useDebitcardUS"

function useDebitcardUSStatusUpdate(
  card_id: string,
  user_id: string,
  options?: Partial<{
    onSuccess: () => void
    onError: () => void
  }>
) {
  const endpoint = endpoints.debitCardUS.update_status
  const queryClient = useQueryClient()

  return useMutation(
    (payload: { status: DebitcardUSStatus; reason: string | undefined }) =>
      endpoint(card_id, user_id).put(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(useDebitcardUS.getQueryKey())
        options?.onSuccess?.()
      },
      onError: () => {
        options?.onError?.()
      },
    }
  )
}

export default useDebitcardUSStatusUpdate
